exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".table_scroll[data-v-02751ca3] {\n  overflow-x: scroll !important;\n}\n.table_width[data-v-02751ca3] {\n  width: 1000px;\n}\n@media screen and (max-width: 640px) {\n.advanced-button[data-v-02751ca3] {\n    border: none;\n    background: transparent !important;\n}\n.search-icon[data-v-02751ca3] {\n    border-radius: 99rem !important;\n    padding: 5px 7px;\n    height: 26px;\n    margin-top: 5px;\n}\n}", ""]);

// exports
